<template>
    <div id="home">
        <div class="ribbon" v-if="!loading"></div>
        <div class="pad-top" v-if="!loading">
            <v-card class="mx-auto" max-width="500">

                <v-img class="white--text align-end" max-height="500px" position="top"
                    src="images/header-login-card.jpg">
                </v-img>

                <v-card-actions>
                    <v-btn text height="auto" class="pt-8 pb-8 mx-auto">
                        <a :href="apiUrl + '/sso/attempt'" id="apidae-connect">
                            <v-img src="images/logo_APIDAE.png" contain height="40px"></v-img>
                            <span>CONNEXION APIDAE</span>
                        </a>
                    </v-btn>

                    <v-btn text height="auto" class="pt-8 pb-8 mx-auto">
                        <router-link to="login">
                            <div style="height: 40px">
                                <v-icon>email</v-icon>
                            </div>

                            <span>CONNEXION EMAIL</span>
                        </router-link>
                    </v-btn>
                </v-card-actions>
            </v-card>

            <v-alert class="mx-auto mt-2 text-center" max-width="500" text color="grey">
                Vous n'avez pas encore de compte ? <br />
              <a href="https://intercom.help/dahub/fr/articles/8499389-foire-aux-questions-connexion"
                    target="_blank">Découvrez comment le créer juste ici</a> 🙂<br />
              Vous n'êtes pas un Office de Tourisme ? <br />
              <a href="https://www.uska.fr/contact" target="_blank">
                Prenez contact avec notre équipe juste ici.
            </a>
            </v-alert>
        </div>

        <div class="mt-5">
            <v-container>
                <v-alert class="mb-5" type="error" dark v-if="noUser">
                    Vous ne possédez pas de compte sur la plateforme. Merci de contacter votre administration pour
                    demander
                    la création d'un compte.
                </v-alert>
                <v-alert class="mb-5" type="error" dark v-else-if="noContract">
                    Votre contrat est périmé.
                </v-alert>
            </v-container>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "Home",
    data() {
        return {
            apiUrl: process.env.VUE_APP_API_URL,
            noUser: false,
            loading: false,
            noContract: false,
        }
    },
    methods: {
        ...mapMutations('account', ['setToken'])
    },
    computed: {
        ...mapState('account', ['user']),
    },
    async created() {
        let query = this.$route.query

        if (query.error !== undefined && query.error === 'no_user') {
            this.noUser = true
        }

        if(query.error !== undefined && query.error === 'no_contract') {
            this.noContract = true
        }

        if (query.token !== undefined && !this.noContract) {
            this.loading = true

           this.setToken(query.token)

            await this.$store.dispatch('account/getCredentials')

            if (!this.user.cgu_validation) {
                this.$router.push('/accept-cgu')
            } else {
                this.$router.push('/home')
            }
        }
    }

}
</script>
